import ReactQuill from "react-quill"


function ReactQuilInput({placeholder=""}){

     const modules = {
        toolbar: [
            // [{ size: [] }],
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["link"],
            // [{ color: [] }, { background: [] }],
            // ["clean"],
        ],
        clipboard: {
            matchVisual: false,
        },
        // imageResize: {
        //   parchment: Quill.import("parchment"),
        //   modules: ["Resize", "DisplaySize"],
        // },
    };
    const formats = [
        "header",
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "indent",
        "link",
        "image",
        "video",
    ];

    return(
        <ReactQuill
            style={{ height: "170px" }}
            theme="snow"
            modules={modules}
            formats={formats}
                                      placeholder={placeholder}
                                    //   defaultValue={emailContent}
                                    //   onChange={setEmailContent}
                                  />
    )

}

export default ReactQuilInput